import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetLocationsByWorkspaceIdQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['Int']['input'];
}>;


export type GetLocationsByWorkspaceIdQuery = { __typename?: 'query_root', workspaceLocations: Array<{ __typename?: 'workspaceLocations', id: number, name: string, workspaceId: number, abbreviation?: string | null, city?: string | null, state?: string | null, workspace: { __typename?: 'workspaces', id: number, name: string } }> };


export const GetLocationsByWorkspaceIdDocument = gql`
    query getLocationsByWorkspaceId($workspaceId: Int!) {
  workspaceLocations(
    where: {workspaceId: {_eq: $workspaceId}}
    order_by: {name: asc}
  ) {
    id
    name
    workspaceId
    abbreviation
    city
    state
    workspace {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLocationsByWorkspaceIdQuery__
 *
 * To run a query within a React component, call `useGetLocationsByWorkspaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByWorkspaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByWorkspaceIdQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetLocationsByWorkspaceIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsByWorkspaceIdQuery, GetLocationsByWorkspaceIdQueryVariables> & ({ variables: GetLocationsByWorkspaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsByWorkspaceIdQuery, GetLocationsByWorkspaceIdQueryVariables>(GetLocationsByWorkspaceIdDocument, options);
      }
export function useGetLocationsByWorkspaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsByWorkspaceIdQuery, GetLocationsByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsByWorkspaceIdQuery, GetLocationsByWorkspaceIdQueryVariables>(GetLocationsByWorkspaceIdDocument, options);
        }
export function useGetLocationsByWorkspaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationsByWorkspaceIdQuery, GetLocationsByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsByWorkspaceIdQuery, GetLocationsByWorkspaceIdQueryVariables>(GetLocationsByWorkspaceIdDocument, options);
        }
export type GetLocationsByWorkspaceIdQueryHookResult = ReturnType<typeof useGetLocationsByWorkspaceIdQuery>;
export type GetLocationsByWorkspaceIdLazyQueryHookResult = ReturnType<typeof useGetLocationsByWorkspaceIdLazyQuery>;
export type GetLocationsByWorkspaceIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationsByWorkspaceIdSuspenseQuery>;
export type GetLocationsByWorkspaceIdQueryResult = Apollo.QueryResult<GetLocationsByWorkspaceIdQuery, GetLocationsByWorkspaceIdQueryVariables>;